import { render, staticRenderFns } from "./contenedoresAdd.vue?vue&type=template&id=27101aaf"
import script from "./contenedoresAdd.vue?vue&type=script&lang=js"
export * from "./contenedoresAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports